import { Injectable } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class AlertandloadingService {
  public loading: any;
  constructor(
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public toast: ToastController
  ) {}

  async showToast(message: string) {
    const toast = await this.toast.create({
      message: message,
      position: "middle",
      duration: 500,
      cssClass: "toastStyle",
    });
    toast.present();
  }

  async showAlert(header: string, message: any) {
    const alertMessage = this.getReadableMessage(message);
    const alertHeader = this.isRateLimitError(message) ? "Please wait" : header;
    const alert = await this.alertCtrl.create({
      cssClass: "dark-alert",
      header: alertHeader,
      message: alertMessage,
      buttons: ["OK"],
    });

    alert.present();
  }

  /**
   * Convert API/HTTP errors into text that is suitable for an end-user alert.
   * Some callers pass the complete HttpErrorResponse while others pass a
   * JSON-encoded version of it, so both forms are handled here.
   */
  getReadableMessage(error: any): string {
    if (this.isRateLimitError(error)) {
      return "You have made too many requests. Please wait a minute and try again.";
    }

    if (error === null || typeof error === "undefined") {
      return "Something went wrong. Please try again.";
    }

    if (Array.isArray(error)) {
      return error.length
        ? this.getReadableMessage(error[0])
        : "Something went wrong. Please try again.";
    }

    if (typeof error === "object") {
      if (error.error) {
        return this.getReadableMessage(error.error);
      }

      if (error.message) {
        return this.getReadableMessage(error.message);
      }

      return "Something went wrong. Please try again.";
    }

    const message = String(error).trim();
    if (!message) {
      return "Something went wrong. Please try again.";
    }

    if (
      (message.charAt(0) === "{" && message.charAt(message.length - 1) === "}") ||
      (message.charAt(0) === "[" && message.charAt(message.length - 1) === "]")
    ) {
      try {
        return this.getReadableMessage(JSON.parse(message));
      } catch (_) {
        // It only looked like JSON; keep the original readable text.
      }
    }

    return message;
  }

  private isRateLimitError(error: any): boolean {
    if (error === null || typeof error === "undefined") {
      return false;
    }

    if (typeof error === "object") {
      if (Number(error.status) === 429) {
        return true;
      }

      return (
        this.isRateLimitError(error.error) ||
        this.isRateLimitError(error.message)
      );
    }

    const value = String(error).toLowerCase();
    return (
      value.indexOf("too many requests") !== -1 ||
      value.indexOf("too many attempts") !== -1 ||
      value.indexOf("http failure response") !== -1 &&
        value.indexOf("429") !== -1 ||
      value.indexOf('"status":429') !== -1
    );
  }

  async presentLoading(message: string) {
    this.loading = await this.loadingCtrl.create({
      cssClass: "loadingStyle",
      message: message,
      spinner: "crescent",
      backdropDismiss: false,
    });
    await this.loading.present();
  }

  async dismissLoading() {
    this.loading.dismiss();
  }

  async showUpdateAlert(version: string, platform: string) {
    const store = platform == "ios" ? "App Store" : "Google Play";
    var link =
      platform == "ios"
        ? "https://www.apple.com/in/app-store/"
        : "https://play.google.com/store/apps/details?id=com.kointrack.wallet";

    const alert = await this.alertCtrl.create({
      cssClass: "app-update-alert",
      header: "Update available",
      subHeader: "Version " + version,
      message:
        '<div class="update-alert-visual" aria-hidden="true">' +
        '<span class="update-arrow">&#8593;</span>' +
        '<span class="update-spark update-spark-one"></span>' +
        '<span class="update-spark update-spark-two"></span>' +
        "</div>" +
        "<p>A newer, improved version of KOINTRACK is ready. Update from " +
        store +
        " to get the latest features and fixes.</p>",
      buttons: [
        {
          text: "NOT NOW",
          role: "cancel",
          cssClass: "update-later-button",
          handler: () => {},
        },
        {
          text: "UPDATE NOW",
          cssClass: "update-now-button",
          handler: () => {
            window.open(link, "_system");
          },
        },
      ],
    });

    await alert.present();
  }
}
